import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Remonte automatiquement en haut de la page à chaque changement de route.
 * À placer une fois à l'intérieur du <BrowserRouter>.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
